import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { ComboCharts } from "../../../../Constant";
import { COMBO_CHART_DATA, COMBO_CHART_OPTION } from "../../../../Data/Charts/GoogleChart";
import { Chart } from "react-google-charts";

const ComboChart = () => {
  return (
    <Col sm="12" className="box-col-12">
      <Card>
        <CommonCardHeader title={ComboCharts} />
        <CardBody className="chart-block">
          <div className="chart-overflow" id="combo-chart">
            <Chart chartType="ComboChart" width="100%" height="500px" data={COMBO_CHART_DATA} options={COMBO_CHART_OPTION} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ComboChart;
